import { LOCALES } from '../../../constants';

export const AI_TRANSLATED_LABEL_ID = '4ff1eeea-17c4-43c0-b1b8-d89b25f09ad3';

// Help Centers translated end to end: every article is AI-translated by
// definition, so no label is needed, and the homepage carries a banner too.
// Hybrid Help Centers (ru, it) are absent on purpose - there the label alone
// decides, per article, and the homepage stays clean.
export const FULLY_AI_TRANSLATED_LOCALES: string[] = [
  LOCALES.ZH_HANT,
  LOCALES.HI,
  LOCALES.KO,
];

export const AI_TRANSLATED_HOMEPAGE_KEY_DEFAULT =
  'notification.bar.homepage.ai-translated';

export const AI_TRANSLATED_HOMEPAGE_KEY_BY_LOCALE: Record<string, string> = {
  // TODO: switch to AI_TRANSLATED_HOMEPAGE_KEY_DEFAULT once that key is
  // translated for ko - it is still English there, while this article-page key
  // does have Korean copy.
  [LOCALES.KO]: 'notification.bar.articlepage.ai-translated',
};

// "This article was translated into {language} using AI." - the wording every
// Help Center gets unless it needs the "not all articles are available" tail.
export const AI_TRANSLATED_ARTICLE_KEY_DEFAULT =
  'notification.bar.articlepage.ai-translated.new';

export const AI_TRANSLATED_ARTICLE_KEY_BY_LOCALE: Record<string, string> = {
  // TODO: switch to 'notification.bar.articlepage.ai-translated.moreinfo' once
  // that key is translated for zh. The key below is the legacy one, hardcoded
  // to "Chinese" with no {language} param, but it is the only zh string that
  // is actually translated today.
  [LOCALES.ZH_HANT]: 'notification.bar.articlepage.ai-translated',
  [LOCALES.HI]: 'notification.bar.articlepage.ai-translated.moreinfo',
};
